<template>
    <v-row >
        <v-col v-if="validateLoad==true" id="base" md="12" style="height: 100%;" class="my-0 py-0" >
            <v-row justify="center" align="center">
                <v-col calign-self="center" cols="auto">
                    <v-row justify="center" >
                        <v-progress-circular
                        :size="70"
                        :width="7"
                        :color="$store.state.colors.primary"
                        indeterminate
                        ></v-progress-circular>                        
                    </v-row> 
                </v-col>
            </v-row>
        </v-col>         
        <v-col v-else id="base" md="12" class="pb-0 mb-0" >
                        
            <v-row justify="start" style="font-size: 23px" class="RestoRegular pl-4">
                Mis Direcciones
            </v-row>
            <v-row justify="center" class="pr-2 mt-4">
                <v-btn @click="goTo()" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    Agregar dirección
                </v-btn>
            </v-row>
            <v-row justify="center" align="start" style="width: 95%; margin: 0 auto">
                <!-- <v-snackbar v-model="alert" class="font" :top="true" color="warning">
                    Ocurrió un problema
                </v-snackbar>  -->
                <v-col>
                    <v-row v-for="(address, index) in addresses" :key="index" style="background-color: #E6E6E6; border-radius: 5px" class="mt-2">
                        <v-col align-self="center" cols="auto">
                            <v-img src='@/assets/resources/user/casa.svg' width="25px" height="25px"></v-img>
                        </v-col>
                        <v-col align-self="center" style="font-size: 12px" class="RestoRegular">
                            <v-row class="RestoBold" style="font-size: 13px">
                                {{address.alias}}
                            </v-row>
                            <v-row>
                                {{address.calle}} {{address.num_exterior}} {{address.num_interior}} {{address.colonia}} CP {{address.cp}}
                            </v-row>
                        </v-col>
                        <!-- <v-col align-self="center" cols="auto" class="RestoBold mx-0 px-0" style="font-size: 10px">
                            Sin Cobertura
                        </v-col> -->
                        <v-col align-self="center" cols="auto" class="ml-2 mr-2" >
                            <v-row class="RestoBold" v-if="address.cobertura == 'Sin Cobertura'" justify="center" style="font-size: 10px">
                                Sin Cobertura
                            </v-row>
                            <v-row justify="center">
                                <a @click="deleteItem(address);" style="font-size: 14px; background-color: transparent; color: red" class="RestoBold">
                                    Eliminar
                                </a>
                            </v-row>
                        </v-col>
<!--                         <v-col @click="$router.push({ name: 'editAddress'})" align-self="center" cols="auto">
                            <a style="font-size: 14px; background-color: transparent" class="RestoBold" :style="{ 'color': $store.state.colors.primary }">
                                Editar
                            </a>
                        </v-col>
                        <v-col align-self="center" cols="auto">
                            <v-radio-group v-model="active" class="my.0 py-0">
                                <v-radio :color="$store.state.colors.primary"  :value="address.alias" class="my-0 py-0">
                                </v-radio>
                            </v-radio-group>
                        </v-col> -->
                    </v-row>
                </v-col>
            </v-row>
            <v-dialog
                v-model="dialog"
                max-width="290"
            >
                <v-card>
                    <v-card-title class="headline"><span>¿Deseas eliminar la <br> dirección?</span></v-card-title>

                    <v-card-text>
                    Se eliminará la dirección ¿Deseas continuar?
                    </v-card-text>

                    <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn @click="dialog=false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                        No
                    </v-btn>

                    <v-btn @click="deleteAddress();dialog=false" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                        Sí
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>            
        </v-col>
    </v-row>
</template>


<script>
import axios from "axios";
export default {
    data() {
        return {
            alert: false,
            dialog:false,
            addresses: null,
            active: null,
            validateLoad:true,
            editedIndex:null,
        }
    },
    created() {
        // console.log(localStorage.getItem("id_cliente"));
        this.$store.dispatch("GET", {url: 'direcciones_c2/' + localStorage.getItem("id_cliente") + '/' + localStorage.getItem("codigo_marca"), headers: {Authorization: localStorage.getItem("token")}})
            .then(response => {
                // console.log(response);
                this.addresses = response.data;
                // localStorage.setItem("addressUser",JSON.stringify(response.data[0]));
                this.active = response.data[0].alias;
                this.validateLoad=false;
            })
            .catch(error => {
                console.log("Error: " + error);
            });
    },
    watch:{
        active()
        {
            // console.log(this.active);
            // for(var i=0;i<this.addresses.length;i++)
            // {
            //     if(this.addresses[i].alias==this.active)
            //     {
            //         // localStorage.setItem("addressUser",JSON.stringify(this.addresses[i]));
            //         console.log(localStorage.getItem("addressUser"));
            //     }
            // }
        }
    },
    methods: {
        goTo(){
            this.$router.push({name: 'newAddress'});
        },
        deleteItem (item) {
            if(this.addresses.length > 1)
            {
                this.dialog=true
                // console.log(item);
                this.editedIndex = this.addresses.indexOf(item);
                // console.log(this.editedIndex);
            }
        },
        async deleteAddress()
        {
          var obj={
              id_direccion:this.addresses[this.editedIndex].id,
          };
        //   console.log(obj);
          await axios
            .post(
              "/eliminar_dir",obj,
              {headers: {Authorization: this.$store.state.token}}
            )
            .then(res => {
              console.log("Respuesta: ", res);
              if(res.data.mensaje=='Direccion eliminada')
              {
                  this.addresses.splice(this.editedIndex,1)
              }
              else{
                this.$store.state.alertState = true;
                this.$store.state.alertMessage = "Ocurrió un problema";
                this.$store.state.alertColor = "warning";
                setTimeout(() => {
                this.$store.state.alertState = false;
                }, 4000);     
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
    }
}
</script>

<style scoped>

</style>